import { RootState } from "../../rootReducer";

export const selectIsLoading = (state: RootState) => state.getCities.loading;
export const getCitiesErrorMessage = (state: RootState) =>
  state.getCities.error;
export const getCitiesDataResponse = (state: RootState) =>
  state.getCities.getCitiesResponse;
